import api from "./api";

export const updateProfile = (payload) => {
  const form = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined && value !== null) form.append(key, value);
  });
  // avatar file থাকলে multipart লাগবে, Laravel এ PUT+file একসাথে issue করে
  // তাই _method spoof ব্যবহার করা হচ্ছে (Laravel এর standard convention)
  form.append("_method", "PUT");
  return api.post("/profile", form).then((res) => res.data);
};

export const updatePassword = (payload) =>
  api.put("/profile/password", payload).then((res) => res.data);
